module.exports = __webpack_public_path__ + "img/logo.c76a9c15.png";